module.exports = __webpack_public_path__ + "static/media/venu.e81440a9.png";